/* ==========================================================================
   el-stat-count.js — result rows in el-clean-water and el-clinical, and the
   day badges in el-timeline (each stage counts when it scrolls into view)
   When a stats list scrolls into view (once), each number counts up from 0
   to its value and its bar fills left to right, row after row (ease-out,
   ~1.6s). Nothing scrolls or snaps the page. Without JS, or with reduced
   motion, the final numbers and bars simply show.
   Markup: list [data-el-count-group] > item [data-el-count-item] with a
   number [data-el-count] and a bar fill [data-el-count-bar].
   ========================================================================== */
(function () {
  'use strict';

  if (window.elStatCountReady) return;
  window.elStatCountReady = true;

  var DURATION = 1600;
  var STAGGER = 180;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); } /* = cubic-bezier(0.33, 1, 0.68, 1) used for the bars */

  /* "92%" → text pieces around each number, e.g. ['', '%'] + [{ num: 92 }];
     "Day 1 - 30" → ['Day ', ' - ', ''] + [{ num: 1 }, { num: 30 }] (every number counts) */
  function parse(text) {
    var re = /\d+(?:[.,]\d+)?/g, pieces = [], nums = [], last = 0, m;
    while ((m = re.exec(text))) {
      pieces.push(text.slice(last, m.index));
      nums.push({ num: parseFloat(m[0].replace(',', '.')), decimals: (m[0].split(/[.,]/)[1] || '').length, comma: m[0].indexOf(',') !== -1 });
      last = m.index + m[0].length;
    }
    if (!nums.length) return null;
    pieces.push(text.slice(last));
    return { pieces: pieces, nums: nums };
  }
  /* progress 0 → 1 */
  function format(p, progress) {
    var out = p.pieces[0];
    p.nums.forEach(function (n, i) {
      var s = (n.num * progress).toFixed(n.decimals);
      if (n.comma) s = s.replace('.', ',');
      out += s + p.pieces[i + 1];
    });
    return out;
  }

  function run(group, items) {
    group.classList.add('is-counted');
    items.forEach(function (item, i) {
      var number = item.querySelector('[data-el-count]');
      if (!number || !number._elCount) return;
      var p = number._elCount, final = number._elFinal, delay = i * STAGGER, start = null;
      function frame(now) {
        if (start === null) start = now + delay;
        var t = Math.min(1, Math.max(0, (now - start) / DURATION));
        number.textContent = t >= 1 ? final : format(p, easeOut(t));
        if (t >= 1) { number.style.width = ''; number.style.minWidth = ''; number.style.whiteSpace = ''; }
        if (t < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    });
  }

  function setup(group) {
    if (group.hasAttribute('data-el-count-init')) return;
    group.setAttribute('data-el-count-init', '');
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var items = Array.prototype.slice.call(group.querySelectorAll('[data-el-count-item]'));
    items.forEach(function (item, i) {
      var bar = item.querySelector('[data-el-count-bar]');
      if (bar) bar.style.setProperty('--el-count-delay', (i * STAGGER) + 'ms');
      var number = item.querySelector('[data-el-count]');
      if (!number) return;
      var p = parse(number.textContent.trim());
      if (!p) return;
      /* Hold the number at its final width (in em, so it follows the font size at
         every breakpoint) so the label beside it never shifts while it counts */
      var size = parseFloat(window.getComputedStyle(number).fontSize) || 16;
      var finalWidth = (number.getBoundingClientRect().width / size) + 'em';
      number.style.width = finalWidth; /* an in-between figure (e.g. 90%) may be wider: it spills */
      number.style.minWidth = finalWidth; /* into the gap instead of pushing the label */
      number.style.whiteSpace = 'nowrap';
      number._elCount = p;
      number._elFinal = number.textContent;
      number.textContent = format(p, 0);
    });
    group.classList.add('el-count-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        run(group, items);
      });
    }, { threshold: 0.25 });
    observer.observe(group);
  }

  function init(root) {
    var start = function () { (root || document).querySelectorAll('[data-el-count-group]').forEach(setup); };
    /* measure the numbers with the real font */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(start, start); else start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
